export enum ListTypeName {
  firstTypeList = 'firstTypeList',
  secondTypeList = 'secondTypeList',
  thirdTypeList = 'thirdTypeList',
}

export enum SimpleListTypeName {
  firstTypeList = 'firstTypeList',
  secondTypeList = 'secondTypeList',
}

export interface SB {
  cancelFirstType: () => void;
}
